// extracted by mini-css-extract-plugin
export default {"interview-modal":"style_interview-modal__FE9Lu","interviewModal":"style_interview-modal__FE9Lu"};